module.exports = __webpack_public_path__ + "static/media/slot3.26fdb37a.jpg";